import React, { useState } from "react";
import "./NotificationPost.css";
import { follow_and_unfollow } from "../../Api/Flask/userapis";

function NotificationPost({selectedFlag=false,type='follow',data}) {
  const [selected, setselected] = useState(selectedFlag);
  let locText = "";
  if (data.location) {
    const st = data.location.split(",");
    let st1 = [];
    if (st.length > 3) {
      st1 = st.slice(Math.max(st.length - 3, 1));
    } else {
      st1 = st.slice(Math.max(st.length - 3, 1));
    }
    locText = st1.join(",");
  }

  const handleFollow = async () => {
    const { sender } = data;
    const uid = localStorage.getItem("uid");

    if (!selected) {
      let follow = await follow_and_unfollow({
        user: uid,
        friend: sender,
        action: "follow",
      });
    } else {
      let unfollow = await follow_and_unfollow({
        user: uid,
        friend: sender,
        action: "unfollow",
      });
    }
    setselected(!selected);
  };

  return (
    <div className="row post-container text-white">
      <div className="img-container-post ">
        <img
          className="profile__pic--small"
          src={process.env.PUBLIC_URL + "/icon.jpg"}
        />
      </div>
      <div className=" flex items-center justify-center p-1">
        <p
          className="notification__body--text"
          style={{
            color: "white",
            fontSize: 14,
            fontWeight: 500,
            paddingBottom: 0,
            lineHeight: "18px",
          }}
        >
          {data.body}
        </p>
      </div>
      { type==="follow" && (!selected ? (
        <div
          onClick={handleFollow}
          className="flex items-center justify-center w-1/2 cursor-pointer "
        >
          <p className="btn">Follow</p>
        </div>
      ) : (
        <div
          onClick={handleFollow}
          className="flex items-center justify-center w-1/2  cursor-pointer"
        >
          <p className="btn">Unfollow</p>
        </div>
      ))}{
        type==='view' && <div className="flex items-center justify-center w-1/2 cursor-pointer ">
        <p className="btn">View</p>
      </div>
      }
      
    </div>
  );
}

export default NotificationPost;
